import React from 'react'
import { gtmEvent } from 'lib/gtm'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import TransactionSummary from '../ReviewBookingNew/transaction-summary'
import { calculateStripeFee } from 'lib/stripe'
import StepDescription from '../step-description'
import { useStyles } from './styles'
import CoachCardSm from 'components/coach-card-small'
import BookingTypeCard from 'components/booking-type-card'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { DownloadMyPGAsection } from 'components/download-mypga-section'

const SummaryLayout = ({
  idOrSlug,
  lessonType,
  lessonTypeId,
  locationId,
  cardBrand,
  lastDigits,
  selectedLessonPackId,
  isComplete,
}) => {
  const {
    title,
    category,
    durationInMinutes,
    coach,
    facilities,
    lessonPacks = [],
  } = lessonType
  const facility = facilities[0]
  const profilePhoto = coach?.coachProfile?.profilePhoto

  const [selectedLessonPack] = lessonPacks.filter(
    lp => lp.id === selectedLessonPackId,
  )
  const { priceInCents, quantity } = selectedLessonPack
  const [isStripeFlatFeeDeducted] = useFeatureFlags([
    flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED,
  ])
  const processingFeeInDollars = isStripeFlatFeeDeducted
    ? 0
    : calculateStripeFee(priceInCents || 0) / 100

  const classes = useStyles()
  const bookNewSessionUrl = `/coach/${idOrSlug}/schedule?lessonTypeId=${lessonTypeId}&locationId=${locationId}&lessonCreditBalanceQuantity=${quantity}`

  const onBookNow = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-another-session-button',
    })
    window.location.href = bookNewSessionUrl
  }

  const onViewCoachOfferings = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-view-coachofferings-button',
    })
    window.location.href = window.location.pathname
  }

  return (
    <Container className={classes.root}>
      <Grid container>
        <Grid item md={7} xs={12}>
          <StepDescription
            stepText=""
            title="Thank you!"
            description="Your purchase is complete. You will receive a confirmation email shortly."
          />
          <TransactionSummary
            title={title}
            priceInCents={priceInCents}
            processingFeeInDollars={processingFeeInDollars}
            cardBrand={cardBrand}
            lastDigits={lastDigits}
          />
          <Typography
            variant="h5"
            style={{ marginBottom: '16px', marginTop: '48px' }}
          >
            Details
          </Typography>
          <CoachCardSm
            coach={{
              name: coach?.name,
              coachAvatar: profilePhoto,
              facilityName: facility?.name,
            }}
          />
          <BookingTypeCard
            category={category}
            quantity={quantity}
            facility={facility}
            title={title}
            durationInMinutes={durationInMinutes}
            isComplete={isComplete}
            lessonPacks={lessonPacks}
          />
          <Divider className={classes.dividerStyles} />
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Button
                color="primary"
                variant="outlined"
                size="large"
                fullWidth
                onClick={onViewCoachOfferings}
              >
                VIEW COACH OFFERINGS
              </Button>
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                onClick={onBookNow}
              >
                BOOK NOW
              </Button>
            </Grid>
          </Grid>
          <DownloadMyPGAsection />
        </Grid>
      </Grid>
    </Container>
  )
}

export default SummaryLayout
